// extracted by mini-css-extract-plugin
export default {"pagination":"Paginacao_pagination__bW7An"};